module.exports = __webpack_public_path__ + "img/isuzu_thumbnail.db355e52.png";